// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "6f35fb7e57c3c0c98a03d2510e472332" + ".css";
};